// Module
var code = "<!-- ko with: DocumentManager --> <!-- ko template: { html: $data.GetTemplate.bind($data) } --><!-- /ko --> <!-- /ko -->";
// Exports
export default code;